import React, { useEffect, useMemo, useState } from "react"
import { useSearch } from "@usereactify/search"
import { Box, Container, Heading, SkeletonText, Stack, Text } from "@chakra-ui/react"

import Link from "@components/Link"
import { useRoutes } from "@hooks/useRoutes"
import TextButton from "@components/TextButton"
import { useContent } from "@hooks/useContent"

export interface SearchBannerProps extends GatsbyTypes.SanitySectionSearchBanner {
  resultCount: number
  breadcrumb: JSX.Element
  isLoading?: boolean
}

const SearchBanner = ({ title, link, theme, resultCount, breadcrumb, isLoading, contentNoResults }: SearchBannerProps) => {
  const [loading, setLoading] = useState(true)
  const { searchTerm } = useSearch()
  const { urlResolver } = useRoutes()

  const resolvedLink = urlResolver(link)

  const TemplateMap: Record<string, string> = {
    "{count}": resultCount.toString(),
    "{results}": resultCount === 1 ? "result" : "results",
    "{term}": searchTerm === "" ? " " : searchTerm,
  }

  const formattedTitle = title
    ?.split(" ")
    .map(part => part.replace(/\{(.*?)\}/g, match => TemplateMap[match] || match))
    .join(" ")

  useEffect(() => {
    if (!isLoading) setLoading(false)
  }, [isLoading])

  // const { getContent } = useContent()
  // const parsedContent = useMemo(() => getContent({ content: contentNoResults }), [getContent, contentNoResults])

  return (
    <Stack alignItems="center" bg={theme === "Dark" ? "brand.beige.dark" : "white"} pt={2} pb={4} px={2}>
      <Box mb={2}>{breadcrumb}</Box>
      <Stack spacing={2}>
        <Heading as="h1" size="h1" fontWeight="light" textAlign="center" minH="72px">
          {loading ? "Loading results" : formattedTitle}
        </Heading>

        {/* {resultCount === 0 && */}
        {/*   ( */}
        {/*     <Container maxWidth={`4xl`}> */}
        {/*       <Text textAlign={`center`} color={`#7B7670`}> */}
        {/*         {parsedContent} */}
        {/*       </Text> */}
        {/*     </Container> */}
        {/*   ) */}
        {/* } */}

        {link && (
          <Link to={`/blogs/journal?q=${searchTerm}`} textAlign={"center"}>
            <TextButton icon="chevronRight" size="lg" fontSize={["16px", "18px"]}>
              {resolvedLink.title}
            </TextButton>
          </Link>
        )}
      </Stack>
    </Stack>
  )
}

export default React.memo(SearchBanner)
